import { render, staticRenderFns } from "./industry-add-or-update.vue?vue&type=template&id=7fcc230a&scoped=true&"
import script from "./industry-add-or-update.vue?vue&type=script&lang=js&"
export * from "./industry-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./industry-add-or-update.vue?vue&type=style&index=0&id=7fcc230a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcc230a",
  null
  
)

export default component.exports